import createReducer from "./createReducer";
import { SUPPRESS_SUCCESS_GROWL, SUPPRESS_ERROR_GROWL } from "utils/constants";
import { CONCEPTS_ACTIONS } from "./actions/Concepts";
import { escapeParensForAPI } from "utils/common";

const initialConceptsState={
	success: true,
	items		:[],
	totalPages	:1,
	totalItems	:0,
	isLoaded: false,
	hasErrorLoading: false,
	isSaving:false,
};

export function loadConcepts(libraryId) {
	return (dispatch) => {
		return dispatch({
			type: CONCEPTS_ACTIONS.FETCH_ALL_CONCEPTS_AJAX,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `creative-libraries/${libraryId}/concepts`,
				success: CONCEPTS_ACTIONS.FETCH_ALL_CONCEPTS_SUCCESS,
				error: CONCEPTS_ACTIONS.FETCH_ALL_CONCEPTS_ERROR,
			},
		});
	};
}


export function fetchConceptByNameAndType(libraryId, conceptName, conceptType){
	/*
		We use this to check if a Concept with a given name exists already, for async validation.
		`conceptName` is only required to be unique per `conceptType`, so that has to be included in the query.
	*/

	return (dispatch) => {
		if(!conceptName){
			return Promise.reject({ success:false, conceptName:"Concept Name is required" });
		}

		let advancedFilter = `all(eq(conceptName,${escapeParensForAPI(conceptName)}),eq(conceptType,${conceptType}))`;

		return dispatch({
			type: CONCEPTS_ACTIONS.FETCH_CONCEPT_BY_NAME_AND_TYPE,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `creative-libraries/${libraryId}/concepts`,
				params: { advancedFilter },
				success: CONCEPTS_ACTIONS.FETCH_CONCEPT_BY_NAME_AND_TYPE_SUCCESS,
				error: CONCEPTS_ACTIONS.FETCH_CONCEPT_BY_NAME_AND_TYPE_ERROR,
			},
		}).then((response) => {
			if(response?.success){
				let concept = response.payload?.data?.items?.[0];
				return Promise.resolve(concept);
			}
		});
	};
}

/**
 * Rename Concept - Action Creator
 * @param {object} values
 */
export function renameConcept(values){
	const { conceptId, libraryId, newFileName }=values;
	return ((dispatch) => {
		return dispatch({
			type: CONCEPTS_ACTIONS.RENAME_CONCEPT_AJAX,
			AJAX: {
				version: 2,
				url: `creative-libraries/${libraryId}/concepts/${conceptId}`,
				method: 'put',
				data: { conceptName: newFileName },
				success: CONCEPTS_ACTIONS.RENAME_CONCEPT_SUCCESS,
				error: CONCEPTS_ACTIONS.RENAME_CONCEPT_ERROR,
			},
			payload:{ conceptId, libraryId },
		});
	});
}

export function deleteConcept(libraryId, conceptId) {
	return ((dispatch) => {
		return (dispatch({
			type: CONCEPTS_ACTIONS.DELETE_CONCEPT_AJAX,
			AJAX: {
				url: `creative-libraries/${libraryId}/concepts/${conceptId}`,
				method: 'delete',
				success: CONCEPTS_ACTIONS.DELETE_CONCEPT_SUCCESS,
				error: CONCEPTS_ACTIONS.DELETE_CONCEPT_ERROR,
			},
			payload:{ conceptId },
		})
		);
	});
}

export function fetchCreativesByConcept(conceptId) {
	return (dispatch) => {
		return dispatch({
			type: CONCEPTS_ACTIONS.FETCH_CREATIVES_BY_CONCEPT_AJAX,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `concepts/${conceptId}/creatives`,
				success: CONCEPTS_ACTIONS.FETCH_CREATIVES_BY_CONCEPT_SUCCESS,
				error: CONCEPTS_ACTIONS.FETCH_CREATIVES_BY_CONCEPT_ERROR,
			},
		});
	};
}

export function duplicateConcept(values) {
	const { libraryId, conceptId, newConceptName, copyVersions } = values;
	return (dispatch) => {
		return dispatch({
			type: CONCEPTS_ACTIONS.DUPLICATE_CONCEPT_AJAX,
			meta: SUPPRESS_ERROR_GROWL,
			AJAX: {
				url: `creative-libraries/${libraryId}/concepts/${conceptId}/duplicate`,
				params:{ copyVersions: copyVersions ? 1 : 0 },
				method: 'post',
				data: { conceptName: newConceptName },
				success: CONCEPTS_ACTIONS.DUPLICATE_CONCEPT_SUCCESS,
				error: CONCEPTS_ACTIONS.DUPLICATE_CONCEPT_ERROR,
			},
		});
	};
}

export const handlers={
	[CONCEPTS_ACTIONS.FETCH_ALL_CONCEPTS_AJAX]		:isLoadingConcepts,
	[CONCEPTS_ACTIONS.FETCH_ALL_CONCEPTS_SUCCESS]	:initConcepts,
	[CONCEPTS_ACTIONS.FETCH_ALL_CONCEPTS_ERROR]		:initErrorConcepts,

	[CONCEPTS_ACTIONS.DUPLICATE_CONCEPT_AJAX]:    duplicateConceptRequest,
	[CONCEPTS_ACTIONS.DUPLICATE_CONCEPT_SUCCESS]: duplicateConceptResponse,
	[CONCEPTS_ACTIONS.DUPLICATE_CONCEPT_ERROR]:   duplicateConceptResponse,
};

function duplicateConceptRequest(state, action) {
	return {
		...state,
		isSaving: true,
	};
}

function duplicateConceptResponse(state, action) {
	return {
		...state,
		isSaving: false,
	};
}

function isLoadingConcepts(state, action) {
	return {
		...state,
		isLoaded: false,
	};
}

function initConcepts(state, action) {
	let { items }=action.payload.data;

	return {
		...state,
		items,
		isLoaded: true,
		hasErrorLoading: false,
	};
}

function initErrorConcepts(state, action) {
	return {
		...state,
		isLoaded: true,
		hasErrorLoading: true,
	};
}


let reducerConfig = {
	typeRoot		:"CONCEPTS",
	actionTypes		:CONCEPTS_ACTIONS,
	actionCreators	:{
		loadConcepts,
		renameConcept,
		deleteConcept,
		fetchCreativesByConcept,
		duplicateConcept,
		fetchConceptByNameAndType,
	},
	initialState	:initialConceptsState,
	handlers,
};

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const Concepts = reducerConfig.actionCreators;
